//Auth
export const SHOW_LOGIN = "SHOW_LOGIN";
export const HIDE_LOGIN = "HIDE_LOGIN";
export const LOG_IN_AS_USER = "LOG_IN_AS_USER";
export const LOG_IN_AS_MANAGER = "LOG_IN_AS_MANAGER";
export const LOG_OUT = "LOG_OUT";
//UI
export const SHOW_SEARCHBOX_ON_TOOLBAR = "SHOW_SEARCHBOX_ON_TOOLBAR";
export const HIDE_SEARCHBOX_ON_TOOLBAR = "HIDE_SEARCHBOX_ON_TOOLBAR";
export const CLOSE_ERROR = "CLOSE_ERROR";
export const RESET_RESULTS = "RESET_RESULTS";
//Fetching
export const START_FETCH = "START_FETCH";
export const FAIL_FETCH = "FAIL_FETCH";
export const FETCH_STORE = "FETCH_STORE";
export const POST_NEW_PRODUCT = "POST_NEW_PRODUCT";
export const DELETE_PRODUCT = "DELETE_PRODUCT";
//Searching to buy
export const SEARCH_BUYING = "SEARCH_BUYING";
//Cart
export const ADD_TO_CART = "ADD_TO_CART";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const CHANGE_QUANTITY = "CHANGE_QUANTITY";
